import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getMessage = createAsyncThunk(
  "Message/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          // If the value is an array, append each item with the same key
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          // For non-array values, just append normally
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(
        `${API_URL.MESSAGE.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createMessage = createAsyncThunk(
  "Message/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(`${API_URL.MESSAGE.SLUG}`, payload);
      const { active_payload } = getState().message;
      dispatch(getMessage(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteMessage = createAsyncThunk(
  "Message/delete",
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(`${API_URL.MESSAGE.SLUG}/${id}`);
      const { active_payload } = getState().message;
      dispatch(getMessage(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editMessage = createAsyncThunk(
  "Message/put",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(`${API_URL.MESSAGE.SLUG}`, payload);
      const { active_payload } = getState().message;
      dispatch(getMessage(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const messageSlice = createSlice({
  name: "message",
  initialState: {
    message_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMessage.fulfilled, (state, action) => {
      state.message_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload } = messageSlice.actions;
export default messageSlice.reducer;
